import React, { useEffect, useState } from "react";
import "./App.scss";
import QRCode from "qrcode";

const App = () => {
  const [qrUrl, setQrUrl] = useState("");
  const searchParams = new URLSearchParams(window.location.search);
  const q = searchParams.get("q");

  useEffect(() => {
    if (!q) return;

    QRCode.toDataURL(q)
      .then((url) => setQrUrl(url))
      .catch((err) => console.error("Failed to generate QR code", err));
  }, [q]);

  return (
    <div className="app-container">
      <img className="coupon" src="./images/coupon50.jpg" alt="Logo" />
      <div className="text">
        譚仔雲南米線港幣$50電子現金券 <br></br>(全港譚仔雲南米線分店適用) <br />
        有效期至: 6/11/2026
        <br />
        <br />
        每張電子現金券，只限用一次
        <br />
      </div>

      {qrUrl && (
        <div className="code-container">
          <img className="qrcode" src={qrUrl} alt="QR Code" />
          <div className="qrcode-text">{q}</div>
        </div>
      )}

      {/* 條款及細則區塊照原樣保留 */}
      <div className="tnc-container">
        <div className="tnc-title">條款及細則:</div>
        <ul className="tnc">
          <ul>
            <li>
              憑此券在有效期內到香港全線任何一間「譚仔雲南米線」分店，即可換領價值港幣$50
              之餐飲食品。
            </li>
            <li>
              此券有效期由 2025 年 11 月 7 日至 2026 年 11 月 6
              日（包括首尾兩日）。
            </li>
            <li>
              如惠顧金額高於港幣$50，必須支付餘額；如惠顧金額低於港幣$20，將不設任何找續。
            </li>
            <li>
              此券不可兌換現金，除飲品加配優惠及學生優惠之外，不可與任何面額之現金劵、或/及其他優惠（包括經譚仔手機應用程式換領的獎賞）同時使用。
            </li>
            <li>請於結帳前出示此券，開具收據後則無法於相關訂單使用此券。</li>
            <li>
              此券可用於支付閣下訂單應付的附加費，例如外賣餐具或外賣容器的附加費，詳情請留意餐牌及店內告示／宣傳物料。
            </li>
            <li>
              此券不適用於任何經譚仔雲南米線手機應用程式點餐之外賣訂單，及外送平台的外賣自取或外送服務。
            </li>
            <li>此券只可使用一次，如有任何損毀、遺失或被竊，將不獲補發。</li>
            <li>
              如有任何爭議，同心飲食有限公司(即「譚仔雲南米線」)保留最終決定權。
            </li>
          </ul>
        </ul>
      </div>
    </div>
  );
};

export default App;
